import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.66675 1.5L12.8134 8.64667C12.8599 8.69304 12.8967 8.74812 12.9218 8.80875C12.947 8.86938 12.9599 8.93437 12.9599 9C12.9599 9.06563 12.947 9.13062 12.9218 9.19125C12.8967 9.25188 12.8599 9.30696 12.8134 9.35333L5.66675 16.5",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
